// onboarding-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'onb.ui.alreadyLinked': 'Esta empresa ya está vinculada a tu usuario. Selecciónala en el selector de clientes en lugar de crearla de nuevo.',
  'onb.ui.personalNotConnected': 'Finanzas personales no está conectado al backend en esta compilación.',
  'onb.ui.personalCreatedLinked': 'Finanzas personales se ha creado y la familia está vinculada.',
  'onb.ui.personalCreatedInvitePending': 'Finanzas personales se ha creado, pero la invitación debe aceptarse desde la notificación.',
  'onb.ui.personalCreated': 'Finanzas personales se ha creado',
  'onb.ui.personalCreateFailed': 'No se pudo crear Finanzas personales.',
  'onb.ui.orgNumberNineDigits': 'El número de organización debe tener 9 dígitos.',
  'onb.ui.alreadyExists': 'Esta empresa ya existe en Plumme.',
  'onb.ui.createNotConnected': 'Crear empresa no está conectado al backend.',
  'onb.ui.companyCreated': 'La empresa se ha creado',
  'onb.ui.companyCreateFailed': 'No se pudo crear la empresa.',
  'onb.ui.chooseSubPersonal': 'Visión personal, economía familiar, objetivos e impuestos, sin necesidad de una empresa.',
  'onb.ui.chooseSubFirm': 'Crea un despacho contable, acepta encargos de clientes o inicia una nueva empresa cliente.',
  'onb.ui.leadVerify': 'Plumme verifica los números de organización noruegos con el Registro de Brønnøysund y configura el acceso.',
  'onb.ui.step1Company': 'Paso 1 · La empresa',
  'onb.ui.back': '← Atrás',
  'onb.ui.creating': 'Creando...',
  'onb.ui.createAndAccept': 'Crear y aceptar',
  'onb.ui.createPersonal': 'Crear Finanzas personales',
  'onb.ui.createCompany': 'Crear empresa',
  'onb.ui.getStarted': 'Empezar',
  'onb.ui.next': 'Siguiente',
});
